import { LandingTitle } from '@modules/Landing/Shared/Ui/LandingTitle/LandingTitle';
import { SimpleFastEasyElement } from '@modules/Landing/Shared/Ui/SimpleFastEasyElement/SimpleFastEasyElement';
import { PDFView } from '@modules/Landing/Shared/Ui/PDFView/PDFView';
import css from './LandingHeader.module.css';
import { EfficiencyPercentage } from '@modules/Landing/Shared/Ui/EfficiencyPercentage/EfficiencyPercentage';
import { IconWithTextWrapper } from '@modules/Landing/Shared/Ui/IconWithTextWrapper/IconWithTextWrapper';
import BillIcon from '@modules/Landing/Shared/Icons/BillIcon';
import BoardIcon from '@modules/Landing/Shared/Icons/BoardIcon';
import { CheckedQuestions } from '@modules/Landing/Shared/Ui/CheckedQuestions/CheckedQuestions';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@configs/AppRoutes';

export const LandingHeader: React.FC = () => {
    const navigate = useNavigate();
    const handleNavigateToTemplatesPage = () => {
        navigate(ROUTES.TEMPLATES);
    };

    return (
        <section className={css.section}>
            <LandingTitle />
            <SimpleFastEasyElement />
            <PDFView />
            <div className={css.container}>
                <EfficiencyPercentage />
                <div className={css.wrapper}>
                    <IconWithTextWrapper
                        text={
                            'Get your Bill of Materials in PDF format in a few minutes'
                        }
                        icon={
                            <BillIcon
                                height={24}
                                width={24}
                                fill={'white'}
                                stroke={'var(--color-text-accent)'}
                                className={css.billIcon}
                            />
                        }
                    />
                    <IconWithTextWrapper
                        text={'Try to use 20+ templates'}
                        icon={
                            <BoardIcon
                                width={24}
                                height={24}
                                fill={'var(--color-text-accent)'}
                            />
                        }
                    />
                </div>
            </div>
            <CheckedQuestions />
            <BasicButton
                extraClassName={css.btn}
                onClick={handleNavigateToTemplatesPage}
            >
                Try our templates
            </BasicButton>
        </section>
    );
};
